// extracted by mini-css-extract-plugin
export default {"upgrade":"_2ZjFb","badgeNew":"_1HyAa"};